import { useEffect, useState } from "react";
import { Trophy, Building2 } from "lucide-react";
import { fetchPublic } from "../lib/content";
import { SectionHeader } from "./SectionHeader";

export const SuccessStories = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    fetchPublic("stories").then(setStories).catch(() => setStories([]));
  }, []);

  if (!stories.length) return null;

  return (
    <section className="py-20 md:py-28" data-testid="success-stories-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <SectionHeader
          eyebrow="Hall of Fame"
          title="Our students. Now placed."
          desc="Real students of TASSEI who walked the path from coursework to job offer."
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="stories-grid">
          {stories.map((s, i) => (
            <article
              key={s.id}
              data-testid={`story-${i}`}
              className="bg-white border border-slate-200 rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:shadow-[#0A192F]/5 transition-all"
            >
              {s.photo ? (
                <div className="aspect-[5/4] overflow-hidden bg-slate-100">
                  <img src={s.photo} alt={s.student_name} className="w-full h-full object-cover" loading="lazy" />
                </div>
              ) : (
                <div className="aspect-[5/4] bg-gradient-to-br from-[#0A192F] via-[#0F2648] to-[#00B37E] flex items-center justify-center">
                  <span className="font-heading text-4xl font-extrabold text-white">
                    {s.student_name?.split(" ").map((p) => p[0]).slice(0, 2).join("")}
                  </span>
                </div>
              )}
              <div className="p-5">
                <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] font-bold text-[#00B37E]">
                  <Trophy className="w-3.5 h-3.5" /> {s.year || "Placed"}
                </div>
                <h3 className="font-heading text-lg font-bold text-[#0A192F] mt-2">{s.student_name}</h3>
                <div className="text-sm text-[#475569] mt-1">
                  <span className="font-semibold">{s.course}</span>
                </div>
                <div className="mt-3 flex items-center gap-2 text-sm text-[#0A192F]">
                  <Building2 className="w-4 h-4 text-[#00B37E]" />
                  <span className="font-bold">{s.company}</span>
                  {s.position ? <span className="text-[#64748B]">· {s.position}</span> : null}
                </div>
                {s.story ? (
                  <p className="mt-3 text-sm text-[#475569] leading-relaxed">{s.story}</p>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
